import { Injectable, Inject } from '@angular/core';
import { Subject, Observable, throwError } from 'rxjs';
import { catchError, map, timeout } from 'rxjs/operators';

import { ApiCommonService } from 'cbc-shared-lib';

import { FEATURES_LIB_CONFIG } from '../../../../../config/features-lib-config.token';
import { FeaturesLibConfig } from '../../../../../config/features-lib-config';

import {
  Sgkd043aService,
  Sgkd043aRequest,
  Sgkd043aResponse
} from 'sg-api';

@Injectable({
  providedIn: 'root'
})
export class UsedSgkd004dSgkd043aService {

  private _rsesult$ = new Subject<Sgkd043aResponse>();

  constructor(
    private sgkd043aService: Sgkd043aService,
    private apiCommonService: ApiCommonService,
    @Inject(FEATURES_LIB_CONFIG) private featuresLibConfig: FeaturesLibConfig) { }

  /**
   * 組織情報取得API呼び出し
   *
   * @memberof UsedSgkd04dSgkd043aService
   */
  getSosikiInfo(): Observable<Sgkd043aResponse> {

    // リクエスト生成
    let request: Sgkd043aRequest = {
    };

    return this.sgkd043aService.doSGKD043APost(this.apiCommonService.setRequestCommon(request), 'response')
      // NOTE:component側に戻り値として値を返却したい場合は、pipe(map())処理内で値を返却する。
      .pipe(
        map(response => {
          // エラーが設定されていないかチェックする
          this.apiCommonService.checkError(response);
          this._rsesult$.next(response.body);
          return response.body;
        }),
        timeout(Number(this.featuresLibConfig.httpTimeout)),
        catchError((err) => {
          this.apiCommonService.dispErrorMessage(err, 'bill', 'SGKD043A');
          return throwError(err.message);
        }
      )
    );
  }
}
